module.exports = __webpack_public_path__ + "static/media/revan.6aa85587.png";